<div>
  <h1
    [innerHTML]="'accueil.avecAcces.titre' | translate"></h1>
  <p class="paragraphe"
    [innerHTML]="'accueil.avecAcces.avis.description' | translate"></p>
</div>
<br /><br />
<div>
  <p class="paragraphe">
    <a class="lien"
      routerLink="/carte"
      [innerHTML]="'accueil.avecAcces.lienAccederALaCarte' | translate"></a>
  </p>
  <p class="paragraphe"
    [innerHTML]="'accueil.avecAcces.lienAccederALaCarteDescription' | translate"></p>

  <p class="paragraphe" *ngIf="estLienAuGuideUtilisateurFourni">
    <a href="" (click)="openDocument('guide_Utilisateur_PGTP_Complet', $event)"
     [innerHTML]="'accueil.avecAcces.lienDuGuideUtilisateur' | translate"></a> <span [innerHTML]="'accueil.avecAcces.lienDuGuideUtilisateurFin' | translate"></span>
  </p>
</div>
